export type RouteTitleConfig = {
  /**
   * Route path pattern using React Router syntax (e.g. "/job/:jobId").
   */
  path: string;
  /**
   * Whether the match should be exact. Defaults to true unless the path is a wildcard.
   */
  end?: boolean;
  /**
   * Document title for the route. Same title for all URLs matching this path.
   */
  title: string;
};

/**
 * Centralised map of application routes to their human-friendly document titles.
 * These titles are leveraged by the page metadata manager to keep document.title and
 * analytics page_view events in sync with client-side navigation.
 */
export const routeTitleConfig: RouteTitleConfig[] = [
  {
    path: '/',
    title: 'Invirtus | Exceptional engineers. Ready to meet.',
  },
  {
    path: '/platform',
    title: 'Invirtus | Screen, Interview, and Rank Candidates Automatically',
  },
  // /talent landing disabled.
  // {
  //   path: '/talent',
  //   title: 'Invirtus | Exceptional engineers. Ready to meet.',
  // },
  {
    path: '/callback',
    title: 'Authentication Callback | Invirtus',
  },
  {
    path: '/auth-callback',
    title: 'Authentication Callback | Invirtus',
  },
  {
    path: '/login',
    title: 'Sign in | Invirtus',
  },
  {
    path: '/signup',
    title: 'Create account | Invirtus',
  },
  {
    path: '/forgot-password',
    title: 'Reset password | Invirtus',
  },
  {
    path: '/reset-password',
    title: 'Set new password | Invirtus',
  },
  {
    path: '/admin/users/cleanup',
    title: 'User cleanup | Invirtus Admin',
  },
  {
    path: '/blog',
    title: 'Blog | Invirtus',
  },
  {
    path: '/blog/:slug',
    title: 'Blog Post | Invirtus',
  },
  {
    path: '/home',
    title: 'Home | Invirtus',
  },
  {
    path: '/jobs',
    title: 'Jobs | Invirtus',
  },
  {
    path: '/job/:jobId',
    title: 'Job Details | Invirtus',
  },
  {
    path: '/talent-pool',
    title: 'Talent Pool | Invirtus',
  },
  {
    path: '/talent-pool/:id',
    title: 'Talent Details | Invirtus',
  },
  {
    path: '/admin',
    title: 'Admin Dashboard | Invirtus',
  },
  {
    path: '/integrations',
    title: 'Integrations | Invirtus',
  },
  {
    path: '/agents',
    title: 'Agents | Invirtus',
  },
  {
    path: '/settings',
    title: 'Settings | Invirtus',
  },
  {
    path: '/billing',
    title: 'Plans and billing | Invirtus',
  },
  {
    path: '/invite/:token',
    title: 'Accept Invitation | Invirtus',
  },
  {
    path: '/invite/:token/complete',
    title: 'Invitation Complete | Invirtus',
  },
  {
    path: '/job/:jobId/cv',
    title: 'Public CV Upload | Invirtus',
  },
  {
    path: '/interview/:invitationToken',
    title: 'Your Assessment | Invirtus',
  },
  {
    path: '/actual-interview/:interviewId',
    title: 'Assessment in Progress | Invirtus',
  },
  {
    path: '/notauthorized',
    title: 'Access Denied | Invirtus',
  },
  {
    path: '/terms',
    title: 'Terms and Conditions | Invirtus',
  },
  {
    path: '/privacy',
    title: 'Privacy Policy | Invirtus',
  },
  {
    path: '/suspended',
    title: 'Account Paused | Invirtus',
  },
  {
    path: '/onboarding/pack-selection',
    title: 'Choose Your Plan | Invirtus',
  },
  {
    path: '/sales-demo',
    title: 'Sales Demo | Invirtus',
  },
  {
    path: '/gitex-challenge',
    title: 'GITEX Africa Challenge | Invirtus',
  },
  {
    path: '/gitex-challenge/cv/:token',
    title: 'Upload Resume | Invirtus Challenge',
  },
  {
    path: '*',
    end: false,
    title: 'Page Not Found | Invirtus',
  },
];

export const DEFAULT_PAGE_TITLE = 'Invirtus';
